<script setup lang="ts">
import { ref } from 'vue'
import { passwordService } from '@/core/services'
import { flashMessage } from '@/utils/FlashMessages'
import { handleError } from '@/utils/ErrorHandler'
import TextInput from '@/components/input/TextInput.vue'

const email = ref('')
const submit = () => {
  passwordService
    .requestReset(email.value)
    .then(() => {
      flashMessage.info(
        'If the email is associated with an account, you will receive an email with instructions on how to reset your password.'
      )
    })
    .catch(handleError)
}
</script>

<template>
  <div class="container">
    <form novalidate>
      <h3>Forgot password ?</h3>

      <div class="form-group">
        <p>
          Enter your email address. If it is associated with an account, you will receive an email with instructions on how to reset your
          password.
        </p>

        <TextInput v-model="email" :name="'email'" :id="'email'" :placeholder="'Email'" :type="'email'" :required="true" />
      </div>

      <button class="submit-button" type="button" @click="submit">Send reset email</button>
    </form>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/styles/input.scss';
@import '@/assets/styles/form.scss';
</style>
